import {
    FETCH_RAINPRO_STORAGE_ITEMS,
    CLEAN_RAINPRO_STORAGE_ITEMS,
    DELETE_RAINPRO_STORAGE_ITEM,
    CHANGE_RAINPRO_STORAGE_ITEM,
    DELETE_RAINPRO_STORAGE_ITEMS,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const RAINPRO_STORAGE_ITEMS_DEFAULT_STATE = {};

const RainproStorageItemsReducer = (state = RAINPRO_STORAGE_ITEMS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_RAINPRO_STORAGE_ITEMS:
            return payload;

        case CHANGE_RAINPRO_STORAGE_ITEM:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, sku: payload.sku, value: payload.value, comment: payload.comment };
                }

                return item;
            }) };

        case CLEAN_RAINPRO_STORAGE_ITEMS:
        case DELETE_RAINPRO_STORAGE_ITEM:
        case DELETE_RAINPRO_STORAGE_ITEMS:
            return RAINPRO_STORAGE_ITEMS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default RainproStorageItemsReducer;
